const loginHelpResetPasswordDeliveryOptionsTemplate = `
    <pwr-reset-password-mfa>
    </pwr-reset-password-mfa>`;
export default loginHelpResetPasswordDeliveryOptionsTemplate;
